import React, { useEffect, useState } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import Wrapper from '../../components/Wrapper/Wrapper';
import { tripTableHeight, tableHeightWithSparkline } from "../../../styleVariables";
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import MUIDataTable from "mui-datatables";
import {
    getDriverLedger
} from "../../../store/actions/homeActionCreator";
import * as logger from "../../../logger";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { numberFormat } from '../../../utils/utils'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import useStyles from '../css/listing-fastag';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { getDateInStringDocumentDDMMMYYYY, getDateInStringDDMMMYYYY } from '../../../utils/utils';
import { Dialog } from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { Form } from 'react-final-form';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete
} from 'mui-rff';
import NotesIcon from '@material-ui/icons/Notes';
import DateFnsUtils from '@date-io/date-fns';
import Divider from '@material-ui/core/Divider';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import InfoDialog from '../../components/Dialog/InfoDialog';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import TelegramIcon from '@material-ui/icons/Telegram';
import queryString from "query-string";
import SuccessDialog from '../../components/Verfication/SuccessDialog';
import FailureDialog from '../../components/Verfication/FailureDialog';
import {
    getSingleFastTagDetails, 
    getFastTagRechargeStatus,
    getBalance,
    getWalletBalance
} from "../../../store/actions/fastagActionCreators";
import InfoIcon from '@material-ui/icons/Info';
import TransactionDetailsSideBar from '../../components/RightSideBar/TransactionDetailsSideBar';
import PaymentDetailsCard from '../../components/Payment/PaymentDetailsCard';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { trackDwebEvent } from '../../analytics';
import { TransactionHistory } from '../../components/TopCard/icons';
import RechargeSuccessIcon from '../../../assets/rounded-green-tick.svg';
import PaymentFailedIcon from '../../../assets/transaction-error-icon-red.svg';
import PaymentPendingIcon from '../../../assets/transaction-pending-icon-orange.svg';
import RechargePendingIcon from '../../../assets/bank-icon-orange.svg';
import RefundSuccessIcon from '../../../assets/refund-successful-green.svg';
import RefundFailureIcon from '../../../assets/refund-pending-orange-icon.svg';
import moment from 'moment';
import FastTagTransactDetailsSideBar from '../../components/FastTagDialogAndSidebar/FastTagTransactDetailsSideBar';
import {
    getPaymentStatus
} from "../../../store/actions/OnlinePaymentActionCreators";
import RechargeFastagSideBar from '../../components/RightSideBar/RechargeFastagSideBar';
import RewardConsumptionDialog from '../../components/Verfication/RewardConsumptionDialog';

const ViewFastagTruck = ({
    dispatchGetSingleFastagVehicleDetails,
    dispatchGetFastTagRechargeStatus,
    dispatchGetSingleFastagBalance,
    dispatchGetPaymentStatus,
    fastag,
    dispatchGetWalletBalance,
    user,
}) => {

    let submit;
    let history = useHistory();
    let search = window.location.search;
    const params = queryString.parse(search);
    let orderId = params["order_id"];
    let rewardAmountUsed = params["rewardAmountUsed"];
    const [initialEmpty, setInitialEmpty] = useState(false);
    const [singleFastagData, setSingleFastagData] = useState({});
    const [settleModalOpen, setSettleModalOpen] = useState(false);
    const [shopCreditPaymentDialog, setShopCreditPaymentDialog] = useState(false);
    const [recall, setRecall] = useState(false);
    const [type, setType] = useState("");
    const [transType, setTransType] = useState("");
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [transactionId, setTransactionId] = useState("");
    const [infoOpen, setInfoOpen] = useState(false);
    const [selectedData, setSelectedData] = useState("");
    const [rechargeFastagOpen, setRechargeFastagOpen] = useState(false);
    const [defaultData, setDefaultData] = useState(null)
    const [successCreation, setSuccessCreation] = useState(false);
    const [failureCreation, setFailureCreation] = useState(false);
    const [transactionData, setTransactionData] = useState({})
    const [transactionDetailsOpen, setTransactionDetailsOpen] = useState(false);
    const [dialogShopCreditPayment, setDialogShopCreditPayment] = useState(false);
    const [eventSent, setEventSent] = useState(false);
    const [fastTagTransactDetailsOpen, setFastTagTransactDetailsOpen] = useState(false);
    const [defaultVehicleData, setDefaultVehicleData] = useState(null)
    const [rewardConsumption, setRewardConsumption] = useState(false);
    const [rewardAmount, setRewardAmount] = useState(0);
    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let fastagIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";

    const classes = useStyles();
    const goToViewFastag = (data) => {
        if(data){
            const fastTagStatus = data && data.status ? data.status : "";
            const vehicleNumberPreffix = data.vehicleNumberPrefix;
            const vehicleNumberSuffix = data.vehicleNumberSuffix;
            const status = data.status;
            const fastTagBalance = data && data && data.balanceAmount ? data.balanceAmount : "";
            history.push({
                pathname: `/fastag/single-truck/${fastagIdValue}`,
                state: {
                    id: fastagIdValue,
                    fastagBalance: fastTagBalance || null,
                    pageTitle: [vehicleNumberPreffix, vehicleNumberSuffix],
                    fastTagId: fastagIdValue
                }
            });
        }
    }
    const handleTransactionDetailsOpen = () => {
        setTransactionDetailsOpen(true)
    }
    const handleTransactionDetailsClose = () => {
        setTransactionDetailsOpen(false)
    }
    useEffect(() => {
        var data = {
            pageNo: 1,
            pageSize: 200
        }

        dispatchGetSingleFastagVehicleDetails(fastagIdValue,
            (data) => {
                if (!eventSent) {
                    /*trackDwebEvent('Dweb Single Shop Page', {
                        shop_id: fastagIdValue,
                        shop_name: data.response && data.response.name ? data.response.name : '',
                        contact_number:data.response && data.response.contactNumber ? data.response.contactNumber : '',
                        balance:data.response && data.response.balance ? data.response.balance : '',
                      });
                      setEventSent(true);*/
                }
                if (data && data.status && data.status.code == 200 && data.response && data.response.txnHistory && data.response.txnHistory <= 0) {
                    setInitialEmpty(true)
                } else {
                    setInitialEmpty(false)
                }
                if(rewardAmountUsed && Number(rewardAmountUsed) != 0){
                    setRewardAmount(rewardAmountUsed)
                    handleRewardsOpen()
                    setTimeout(() => {
                        handleRewardsClose(data)
                    }, 3000);
                }else if(rewardAmountUsed && Number(rewardAmountUsed) == 0){
                    goToViewFastag(data)
                }
                if (orderId) {
                    setDefaultVehicleData(data)
                    dispatchGetPaymentStatus({
                        orderId: orderId
                    }, (response) => {
                        if (response && response.status && response.status.code == 200) {
                            if (response.response.message == "Transaction Failed.") {
                                handleFailureOpen()
                                setTimeout(() => {
                                    handleFailureClose(data)
                                }, 3000);
                            }else if (response.response && response.response.rewardAmountUsed && Number(response.response.rewardAmountUsed) != 0) {
                                setRewardAmount( response.response.rewardAmountUsed)
                                handleRewardsOpen()
                                setTimeout(() => {
                                    handleRewardsClose(data)
                                }, 3000);
                            } else {
                                handleSuccessOpen()
                                setTimeout(() => {
                                    handleSuccessClose(data)
                                }, 3000);
                            }
                        } else {
                            handleFailureOpen()
                            setTimeout(() => {
                                handleFailureClose(data)
                            }, 3000);
                        }
                    }, () => {
                        handleFailureOpen();
                        setTimeout(() => {
                            handleFailureClose(data)
                        }, 3000);
                    })
                }
            },
            () => {
                logger.log("singleShopComponent", "Single Fastag Fetch Failed");
            }
        )
    }, [recall]);

    useEffect(() => {
        if (fastag && fastag.singleFastTagDetails) {
            if (initialEmpty && fastag.singleFastTagDetails.txnHistory && fastag.singleFastTagDetails.txnHistory.length > 0) {
                setInitialEmpty(false)
            }
            setSingleFastagData(fastag.singleFastTagDetails);
        }
    }, [fastag.singleFastTagDetails]);
    const refreshBalance= ()=>{
        dispatchGetSingleFastagBalance(fastagIdValue,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    setRecall(!recall);
                } else {
                }
            },
            () => {
            }
        )
    }
    const handleRechargeFastagOpen = (e,data) => {
        e.preventDefault()
        e.stopPropagation()
        setDefaultData({
            id: fastagIdValue,
            vehicleId:fastagIdValue,
            amount: data && data.rechargeAmount?data.rechargeAmount:null
        })
        setFastTagTransactDetailsOpen(false);
        dispatchGetSingleFastagVehicleDetails(fastagIdValue,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    dispatchGetWalletBalance(data,(res)=>{
                        if(data && data.status && data.status.code == 200){
                            setRechargeFastagOpen(true)
                        }
                    },()=>{

                    })
                }else{
                    setDefaultData(null);
                }
            },
            () => {
                setDefaultData(null);
            }
        )
        //setRechargeFastagOpen(true)
    }
    const handleRechargeFromDetailsSideBar = (e,data) => {
        setFastTagTransactDetailsOpen(false);
        setRechargeFastagOpen(true)
    }

    const handleRechargeFastagClose = (entityData) => {
        setRecall(!recall);
        setDefaultData(null);
        setRechargeFastagOpen(false);
        setFastTagTransactDetailsOpen(false);
    }

    const handleSuccessOpen = () => {
        setSuccessCreation(true)
    }
    const handleSuccessClose = (data) => {
        setSuccessCreation(false)
        goToViewFastag(data&&data.response?data.response:null)
    }
    const handleFailureOpen = () => {
        setFailureCreation(true)
    }
    const handleFailureClose = (data) => {
        setFailureCreation(false)
        goToViewFastag(data&&data.response?data.response:null)
    }
    const handleRewardsOpen = () => {
        setRewardConsumption(true)
    }
    const handleRewardsClose = (data) => {
        setRewardConsumption(false)
        goToViewFastag(data&&data.response?data.response:null)
    }
    const handleRowClick = (data) => {
        setDefaultData({
            id: fastagIdValue,
            vehicleId:fastagIdValue,
            amount: data && data.rechargeAmount?data.rechargeAmount:null
        })
        if (data && data.rechargeId) {
            dispatchGetFastTagRechargeStatus(data && data.rechargeId ? data.rechargeId : "",
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('View FastTag Truck Dweb', 'Get Fast Tag Recharge Status Successfull');
                        setFastTagTransactDetailsOpen(true);
                    }
                },
                () => {
                    logger.log('View FastTag Truck Dweb', 'Get Fast Tag Recharge Status Failed');
                }
            )
        }
    }
    const getStatusIcons = (data) => {
        let src = null
        if (data) {
            if (data.paymentStatus && data.paymentStatus == 'SUCCESS') {
                if (data.rechargeStatus && data.rechargeStatus == 'SUCCESS') {
                    src = RechargeSuccessIcon;
                } else {
                    if (data.rechargeStatus && data.rechargeStatus == 'PENDING') {
                        src = RechargePendingIcon;
                    } else if (data.rechargeStatus && data.rechargeStatus == 'FAILED') {
                        if (data.refundStatus && data.refundStatus == 'SUCCESS') {
                            src = RefundSuccessIcon
                        } else {
                            src = RefundFailureIcon
                        }
                    }
                }
            } else {
                if (data.paymentStatus && data.paymentStatus == 'PENDING') {
                    src = PaymentPendingIcon
                } else {
                    src = PaymentFailedIcon
                }
            }
        }
        if (src)
            return <img src={src} />
        else
            return null;
    }
    const getStatusText = (data) => {
        if (data) {
            if (data.paymentStatus && data.paymentStatus == 'SUCCESS') {
                if (data.rechargeStatus && data.rechargeStatus == 'SUCCESS') {
                    return "Recharge Successful"
                } else {
                    if (data.rechargeStatus && data.rechargeStatus == 'PENDING') {
                        return "Recharge Pending"
                    } else if (data.rechargeStatus && data.rechargeStatus == 'FAILED') {
                        if (data.refundStatus && data.refundStatus == 'SUCCESS') {
                            return "Refund Successful"
                        } else {
                            return "Refund Initiated"
                        }
                    }
                }
            } else {
                if (data.paymentStatus && data.paymentStatus == 'PENDING') {
                    return "Transfer Pending"
                } else {
                    return "Transfer Failed"
                }
            }
        }
        return null
    }
    const getTypesColor = (data) => {
        if (data) {
            if (data.paymentStatus && data.paymentStatus == 'SUCCESS') {
                if (data.rechargeStatus && data.rechargeStatus == 'SUCCESS') {
                    return "#00875a"
                } else {
                    if (data.rechargeStatus && data.rechargeStatus == 'PENDING') {
                        return "#fc7614"
                    } else if (data.rechargeStatus && data.rechargeStatus == 'FAILED') {
                        if (data.refundStatus && data.refundStatus == 'SUCCESS') {
                            return "#00875a"
                        } else {
                            return "#fc7614"
                        }
                    }
                }
            } else {
                if (data.paymentStatus && data.paymentStatus == 'PENDING') {
                    return "#fc7614"
                } else {
                    return "#ff3f3f"
                }
            }
        }
        return null
    }
    const muiColumns = [
        {
            name: "date",
            label: " ",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = singleFastagData.txnHistory[dataIndex];
                    return (
                        <>
                            <div className={classes.nameDivIcon}>
                                <div className={classes.iconDiv}>
                                    {getStatusIcons(data)}
                                </div>
                            </div>
                        </>
                    )
                }
            },
        },
        {
            name: "displayName",
            label: "Status",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = singleFastagData.txnHistory[dataIndex];
                    return (
                        <div>
                            {getStatusText(data)}
                        </div>
                    )
                }
            },
        },
        {
            name: "paymentTime",
            label: "Payment Date & time",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value) => {
                    return (
                        <div>{value ? moment(value * 1000).format('DD MMM YYYY, h:mm:ss a') : ""}</div>
                    )
                }
            },
        },
        {
            name: "rechargeAmount",
            label: "Amount",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = singleFastagData.txnHistory[dataIndex];
                    return (
                        <>
                            <div className={classes.amountDiv}>
                                <div className={classes.statusDiv}>
                                    <div style={{ color: getTypesColor(data) }} className={classes.amountTxt}>
                                        <span>{numberFormat(data.rechargeAmount)}</span>
                                    </div>
                                </div>
                                {/* {data && data.rechargeStatus && data.rechargeStatus == 'SUCCESS' && <div className={classes.actionDiv}>
                                    <Button onClick={(e) => { handleRechargeFastagOpen(e,data)}} className={classes.rechargeAgain}>Recharge Again</Button>
                                </div>} */}
                            </div>
                        </>
                    )
                }
            },
        },

    ];
    const muiData = singleFastagData.txnHistory;
    const options = {
        rowsPerPage: 100,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        fixedHeader: true,
        tableBodyHeight: tableHeightWithSparkline,
        selectableRows: 'none',
        searchOpen: false,
        search: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        onRowClick: (rowData, rowMeta) => {
            handleRowClick({
                ...muiData[rowMeta.dataIndex],
                index: muiData[rowMeta.dataIndex],
            })
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

        },
        searchProps: {
            variant: "outlined",
            InputProps: {
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            },
            onBlur: (e) => {
            },
            onKeyUp: (e) => {
            },
            onKeyDown: (event) => {
                if (event.keyCode === 27) {
                }
            }
        },
        searchPlaceholder: 'Search transactions',
        textLabels: {
            body: {
                noMatch: "Sorry, no transactions found",
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            }
        }
    };


    const handleConfirm = () => {
        setShopCreditPaymentDialog(false);
        setRecall(!recall);
    }

    const handleDeleteDialogClose = () => {
        setDeleteDialog(false);
    }

    const handleDeleteDialogOpen = (data) => {
        const transactionId = data.id;
        setTransactionId(transactionId);
        setDeleteDialog(true);
    }

    const onDeleteTransaction = () => {

    }

    const handleSingleTransactionEdit = (data) => {
        const transactionId = data.id;
    }

    const handleBalanceClose = () => {
        setShopCreditPaymentDialog(false);
    }

    const handleInfoClick = () => {
        setInfoOpen(true);
    }

    const handleInfoClose = () => {
        setInfoOpen(false);
    }
    const goSingleShopCredit = () => {
        setDialogShopCreditPayment(true);
        setTransType("Credit");
    }
    const goSingleShopPayment = () => {
        setDialogShopCreditPayment(true);
        setTransType("Payment");
    }
    const handleShopCreditPaymetClose = () => {
        setDialogShopCreditPayment(false);
        setRecall(!recall);
    }
    const handleShopCreditPaymentConfirm = () => {
        setDialogShopCreditPayment(false);
        setRecall(!recall);
    }

    const handleFastTagDetailsClose = () => {
        setFastTagTransactDetailsOpen(false);
        setDefaultData(null)
    }

    return (
        <>
            <Wrapper>
                <Paper className={classes.pageContentDIv} elevation={3}>
                    <div>
                        <div className={classes.drflexDetails}>
                            {singleFastagData && singleFastagData.status && !singleFastagData.isBalanceAvailable && singleFastagData.status =="ACTIVE"?<>
                                <div className={classes.balanceRefreshDiv}>
                                    <span className={classes.notSupported}>Balance Check is not currently Supported for&nbsp;{singleFastagData && singleFastagData.bankName ? singleFastagData.bankName : ""}</span> 
                                </div>
                            </>:<><div className={classes.balanceRefreshDiv}>
                                {singleFastagData && singleFastagData.balanceAmount && <div className={classes.balanceDiv}>
                                    <span className={classes.fastagBalance}>{numberFormat(Number(singleFastagData.balanceAmount))}</span>
                                    &nbsp;
                                    {singleFastagData && singleFastagData.balanceFetchedAt && <span className={classes.lastChecked}>
                                        (last updated on <span className={classes.balanceFetchedAt}>{singleFastagData.balanceFetchedAt?moment(singleFastagData.balanceFetchedAt * 1000).format('DD MMM YYYY, h:mm:ss a') : ""}</span>)
                                    </span>}
                                </div>}
                                <div className={classes.drflex} style={{ marginBottom: 12 }}>
                                    <Button variant="contained" classes={{
                                        disabled:classes.disabledBtn
                                    }} className={classes.refreshBalanceButton} disabled={singleFastagData && singleFastagData.isBalanceAvailable && singleFastagData.balanceRemainingAttempts && singleFastagData.balanceRemainingAttempts > 0 ? false : true} onClick={() => { refreshBalance() }}>
                                        <span className={classes.ptV1}>Refresh Balance </span>
                                    </Button>
                                    {singleFastagData && singleFastagData.balanceAttemptsMessage && singleFastagData.isBalanceAvailable && <span className={classes.balanceAttemptsMessage}>{singleFastagData.balanceAttemptsMessage}</span>}
                                </div>
                                <div className={classes.drflex}>
                                    {/* {singleFastagData && singleFastagData.warningMessage? <>
                                        <InfoOutlinedIcon style={{color:"#ff0000",fontSize:8}} />
                                        <span style={{color:"#ff0000",fontSize:10,marginLeft:8}}>{singleFastagData.warningMessage}</span>
                                    </> : <>
                                    <InfoOutlinedIcon style={{color:"#6d7278",fontSize:8}} />
                                    <span style={{color:"#6d7278",fontSize:10,marginLeft:8}}>You can check the Balance 3 times per Recharge</span>
                                    </>} */}
                                    {singleFastagData && singleFastagData.isBalanceAvailable && singleFastagData.balanceRemainingAttempts && singleFastagData.balanceRemainingAttempts > 0 ?<>
                                    <InfoOutlinedIcon style={{color:"#6d7278",fontSize:12}} />
                                    <span style={{color:"#6d7278",fontSize:10,marginLeft:8}}>You can check the Balance 3 times per Recharge</span>
                                    </> : <>
                                        <InfoOutlinedIcon style={{color:"#ff0000",fontSize:12}} />
                                        <span style={{color:"#ff0000",fontSize:10,marginLeft:8}}>Balance cannot be checked until next Recharge</span>
                                    </>}
                                </div>
                            </div></>}
                            <div className={classes.vehicleDetailsDiv}>
                                <div className={classes.vehicleNumberDiv} >
                                    <Typography className={classes.subTitle}>Vehicle Number</Typography>
                                    <Typography className={classes.vehicleNumber} >
                                        <span>{singleFastagData && singleFastagData.vehicleNumberPrefix ? singleFastagData.vehicleNumberPrefix : ""}</span>
                                        &nbsp;
                                        <span>{singleFastagData && singleFastagData.vehicleNumberSuffix ? singleFastagData.vehicleNumberSuffix : ""}</span>
                                    </Typography>
                                </div>
                                <div className={classes.bankNameDiv}>
                                    <Typography className={classes.subTitle}>Bank Name</Typography>
                                    <Typography className={classes.bankName} >
                                        {singleFastagData && singleFastagData.bankName ? singleFastagData.bankName : ""}
                                    </Typography>
                                </div>
                                {singleFastagData && singleFastagData.bankIconUrl && <div className={classes.bankIconDiv} >
                                    <img className={classes.bankIcon} src={singleFastagData.bankIconUrl} />
                                </div>}
                            </div>
                        </div>
                        <div className={classes.dividerDiv}></div>
                        <div className={classes.tableDiv}>
                            <div className={classes.tableToolBar}>
                                <div className={classes.tableTitle}>
                                    <TransactionHistory className={classes.tableTitleIcon} />
                                    <Typography className={classes.title}>Recharge History</Typography>
                                </div>
                            </div>
                            {initialEmpty ? <div className={classes.emptyStateDiv}>
                                <img src={`${process.env.PUBLIC_URL}/assets/images/fastag_empty.svg`} alt="Empty State Image" />
                                <Typography className={classes.emptyTxt}>All FASTag Recharges done through TransportBook will be shown here</Typography>
                            </div> : <MUIDataTable title={""} className={classes.fastTagRechargeTable} data={muiData} columns={muiColumns} options={options} />}
                        </div>
                    </div>
                    {/* <div className={classes.dividerDiv}></div>
                    <div className={classes.singleShopTable}>
                        <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
                    </div> */}
                </Paper>
            </Wrapper>
            {successCreation && <SuccessDialog selectedValue={defaultVehicleData} open={successCreation} title={"Payment Successful"} onClose={handleSuccessClose} />}
            {failureCreation && <FailureDialog selectedValue={defaultVehicleData}  open={failureCreation} title={"Payment Failed"} onClose={handleFailureClose} />}
            {fastTagTransactDetailsOpen &&
                <FastTagTransactDetailsSideBar rightSideBarOpen={fastTagTransactDetailsOpen} toggleRightSideBar={handleFastTagDetailsClose} rechargeAgain={handleRechargeFromDetailsSideBar} />
            }
            {rewardConsumption && <RewardConsumptionDialog selectedValue={defaultData}  open={rewardConsumption} subTitle={numberFormat(Number(rewardAmount))} title={"You Saved"} onClose={handleRewardsClose} />}
               {rechargeFastagOpen && <RechargeFastagSideBar
                    rightSideBarOpen={rechargeFastagOpen}
                    defaultData={defaultData}
                    sideBarTitle={'Recharge FASTag'}
                    handleSubmit={event => { }}
                    toggleRightSideBar={handleRechargeFastagClose}
       ><div></div></RechargeFastagSideBar>}
        </>
    );
}

const mapStateToProps = (state) => ({ user: state.user, fastag: state.fastag });
const mapDispatchToProps = (dispatch) => ({
    dispatchGetSingleFastagVehicleDetails: (id, onSuccess, onFailure) => {
        dispatch(getSingleFastTagDetails(id, onSuccess, onFailure));
    },
    dispatchGetPaymentStatus: (data, onSuccess, onError) => {
        dispatch(getPaymentStatus(data, onSuccess, onError))
    },
    dispatchGetSingleFastagBalance: (id, onSuccess, onFailure) => {
        dispatch(getBalance(id, onSuccess, onFailure));
    },
    dispatchGetFastTagRechargeStatus: (transactionId, onSuccess, onFailure) => {
        dispatch(getFastTagRechargeStatus(transactionId, onSuccess, onFailure))
    },
    dispatchGetWalletBalance: (data, onSuccess, onError) => {
        dispatch(getWalletBalance(data, onSuccess, onError))
    }
})

const ViewFastagTruckWithRouter = withRouter(ViewFastagTruck);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewFastagTruckWithRouter);